import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { QUERY_KEY } from "@/modules/grupos-diagnostico/components/grupos-diagnostico-table/GruposDiagnosticoTable";
import { getGrupoArray } from "@/modules/grupos-diagnostico/firestore";
import useUserStore from "@/modules/users/store";

type TGetGroupResponse = Awaited<ReturnType<typeof getGrupoArray>>;

/**
 * Get ideia from url params
 * @param empresaId - id
 * @returns - Ideia or null if not found
 */
function useQueryGroup(empresaId: string = "") {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const empresaProjeto = empresaId || activeEmpresaId;
  const { id } = useParams<{ id: string; idProjeto: string }>();

  return useQuery<TGetGroupResponse, FirestoreError, TGruposDiagnostico[]>({
    queryKey: [QUERY_KEY, id, empresaProjeto],
    queryFn() {
      if (!empresaProjeto) {
        throw new Error("Empresa não selecionada");
      }
      if (!id) {
        throw new Error("Nenhum questionario");
      }

      return getGrupoArray(empresaProjeto, id);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }

      return dataResponse.docs.map((document_) => document_.data());
    },
    enabled: !!id && !!empresaProjeto
  });
}

export default useQueryGroup;
